<template>
  <div class="finish-container">
    <!-- title -->
    <div class="finish-container__title">
      <headers :params="hraderT"></headers>
    </div>
    <div class="finish-container__body">
      <div class="img_container">
        <img src="../../../assets/images/finish.png" alt="">
        <p>恭喜您，下载成功！</p>
      </div>
      <div class="watch_mode">
        <div class="watch_mode__title">您可以通过以下两个方式进行查看：</div>
        <div class="watch_mode__content">
          <p class="watch_mode__content-item">方式一：在电脑端“我的方案和规范-我下载的”进行查看；</p>
          <p class="watch_mode__content-item">方式二：在手机端查看。文件将发送到您的邮箱：</p>
          <p class="watch_mode__content-item">
            <input type="text" placeholder="例如：289778997@qq.com" v-model="email">
            <button @click="sendEmail">发送</button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headers from '@/components/headers'
import {Toast} from 'vant'
import {regular} from '@/utils/regular'
import { batchDownload } from '@/api/solutions/solution'
import { toLogin } from '@/utils/common'
export default {
  name: 'selection-download-finish',
  components: {headers},
  data () {
    return {
      hraderT: {
        title: '河姆渡方案馆',
        lefticon: true
      },
      email: null,
      bizId: null,

      toast: null
    }
  },
  mounted () {
    this.bizId = this.$route.params.id
  },
  methods: {
    sendEmail () {
      // 发送邮箱
      if (!this.email || !regular.email.test(this.email)) {
        Toast('请输入正确的邮箱地址')
        return
      }
      this.toast = Toast.loading({
        message: '发送中...',
        forbidClick: true,
        duration: 0
      })
      batchDownload(this.bizId, this.email).then(result => {
        if (result.status === 200 && result.data && result.data.code === 460) {
          // 登录失效
          this.toast.clear()
          toLogin()
          return
        }
        if (result.status === 200 && result.data && result.data.respCode === '0000') {
          // 下载完成
          this.toast.clear()
          Toast.success('发送成功')
        } else {
          this.toast.clear()
          Toast.fail(result.data.respDesc)
        }
      })
    }
  }
}
</script>

<style  lang="scss">
.finish-container{
  width: 100%;
  height: 100%;
  background-color: #fff;
  &__title{
    box-shadow:0px 1px 0px 0px rgba(0,0,0,0.1);
  }
  &__body{
    padding: 0 16px;
    box-sizing: border-box;
    .img_container{
      img{
        margin-top: 40px;
        width: 49px;
        height: 49px;
        margin-bottom: 18px;
      }
      font-size:18px;
      font-weight: bold;
      color:rgba(51,51,51,1);
      line-height:18px;
      text-align: center;
      margin-bottom: 20px;
    }
    .watch_mode{
      &__title{
        font-size:15px;
        color:rgba(51,51,51,1);
        line-height:21px;
        margin-bottom: 8px;
      }
      &__content{
        &-item{
          font-size:15px;
          color:rgba(153,153,153,1);
          line-height:21px;
          margin-bottom: 8px;
          display: flex;
          flex-direction: row;
          align-items: center;
          input{
            width:295px;
            height:45px;
            background:rgba(255,255,255,1);
            border-radius:3px;
            border:1px solid rgba(235,235,235,1);
            padding-left: 14px;
            box-sizing: border-box;
            outline: none;
          }
          button{
            vertical-align: top;
            border: none;
            outline: none;
            width:70px;
            height:45px;
            background:rgba(47,123,255,1);
            border-radius:0px 3px 3px 0px;
            font-size:15px;
            color:rgba(255,255,255,1);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/solutions/template/download_finish.vue